import gql from 'graphql-tag';

export default gql`
  query baseUoms {
    baseUoms {
      nameLocal
      name
      nameEn
      nameVn
    }
  }
`;
